import { render, staticRenderFns } from "./editRecipient.vue?vue&type=template&id=0a35f7a7&scoped=true&"
import script from "./editRecipient.vue?vue&type=script&lang=js&"
export * from "./editRecipient.vue?vue&type=script&lang=js&"
import style0 from "./editRecipient.vue?vue&type=style&index=0&id=0a35f7a7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a35f7a7",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
